import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_CONFIG, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { toggleDagBookmarkApi } from '@/entities/dag/api';
import type { ToggleDagBookmarkRequest, ToggleDagBookmarkResponse } from '@/entities/dag/domain/types';

export const useToggleDagBookmarkMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ToggleDagBookmarkResponse, Error, ToggleDagBookmarkRequest>({
    mutationFn: (request) => toggleDagBookmarkApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dagKeys.all });

      notification.success({
        message: NOTIFICATION_MESSAGES.DAG_BOOKMARK_UPDATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.DAG_BOOKMARK_UPDATE_SUCCESS_DESC,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.SUCCESS,
      });
    },
    onError: (error) => {
      console.error('Failed to toggle DAG bookmark:', error);

      notification.error({
        message: NOTIFICATION_MESSAGES.DAG_BOOKMARK_UPDATE_ERROR,
        description: error.message || NOTIFICATION_MESSAGES.DAG_BOOKMARK_UPDATE_ERROR_DESC,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.ERROR,
      });
    },
  });
};
